import { DomainEvent } from '@swoft/core';

/**
 * Domain event raised when a task is marked as completed.
 * 
 * This event triggers project progress updates, workload rebalancing,
 * and completion analytics across the development workflow.
 */
export class TaskCompleted implements DomainEvent {
  readonly type = 'TaskCompleted';
  readonly occurredAt: Date;
  readonly eventVersion = 1;
  readonly data: Record<string, any>;

  constructor(
    public readonly aggregateId: string,
    public readonly completedBy?: string,
    public readonly completedAt: Date = new Date()
  ) {
    this.occurredAt = this.completedAt;
    this.data = {
      completedBy: this.completedBy,
      completedAt: this.completedAt
    };
  }
}